/*
 * Post-item.ts
 * Description: Includes the declaration
 * of function for creating a new item
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting an item from the cart
 *
 * @return {Object} Promise - refreshed cart
 * @param {String} slug - id of the restaurant
 */
// TODO: Create an interface for the data
export function postItem(slug: string, data) {
    const jwt =  localStorage.getItem('jwt');
    const id = localStorage.getItem(slug);
    return new Promise ((resolve, reject) => {
        Axios({
            url: APIURL + 'carts',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                guest_id: id,
                ...data,
            },
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
